import React from 'react';
import T from 'prop-types';
// styles
import styles from './MenuBurger.mod.css';
import classnames from 'classnames/bind';

let cx = classnames.bind(styles);

const MenuBurger = ({ isLogged, toggleMenu, isMenuOpen }) => (
  <div className={cx('menuBurgerWrapper')} onClick={toggleMenu}>
    <span className={cx('menuBurger', { open: isMenuOpen })}>
      <span />
      <span />
      <span />
    </span>
  </div>
);

MenuBurger.propTypes = {
  toggleMenu: T.func.isRequired,
  isMenuOpen: T.bool.isRequired
};

export default MenuBurger;



// WEBPACK FOOTER //
// ./src/components/MainHeader/components/MenuBurger.jsx